import { GraphqlChannel } from '@/features/graphql/constants'
import { oauthLink } from '@/features/graphql/links/auth'
import { httpLink } from '@/features/graphql/links/http'
import { missingNetworkConnectionLink } from '@/features/graphql/links/missingNetworkConnection'
import { typePolicies } from '@/features/graphql/typePolicies'
import { ApolloClient, InMemoryCache, from } from '@apollo/client'

export const getClient = (uri: string, language: string, channel: GraphqlChannel) =>
    new ApolloClient({
        link: from([missingNetworkConnectionLink, oauthLink, httpLink(uri, language, channel)]),
        cache: new InMemoryCache({ typePolicies }),
    })
